import type { Comparator } from '@domain/types/filters';

export type FlagOption = { label: string; value: FlagSelection };
export type FlagSelection = 'show' | 'hide';
export type FlagMode = 'count' | 'exists';

export const flagSelectionToFilter = (
  selection: FlagSelection,
  mode: FlagMode = 'count',
): { comparator: Comparator; values: string[] } => {
  if (mode === 'exists') {
    return { comparator: selection === 'show' ? 'ex' : 'nex', values: [] };
  }
  return {
    comparator: selection === 'show' ? 'gt' : 'lt',
    values: selection === 'show' ? ['0'] : ['1'],
  };
};

export const filterToFlagSelection = (comparator: string, values: string[]): FlagSelection | null => {
  if (comparator === 'gt' && values[0] === '0') return 'show';
  if (comparator === 'lt' && values[0] === '1') return 'hide';
  if (comparator === 'ex') return 'show';
  if (comparator === 'nex') return 'hide';
  return null;
};

export const FLAG_OPTIONS: Array<{ label: string; value: FlagSelection }> = [
  { label: 'SHOW', value: 'show' },
  { label: 'HIDE', value: 'hide' },
];
